import { render, staticRenderFns } from "./connection.vue?vue&type=template&id=f4d38e2e&scoped=true&"
import script from "./connection.vue?vue&type=script&lang=js&"
export * from "./connection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4d38e2e",
  null
  
)

export default component.exports